export enum IdentityProvider {
    UNKNOWN = 0,
    SKILLSTOWN = 1,
    ECONNECT = 2,
}

export const providerTranslationMap: Record<IdentityProvider, string> = {
    [IdentityProvider.UNKNOWN]: 'unknown',
    [IdentityProvider.SKILLSTOWN]: 'ID-Governor',
    [IdentityProvider.ECONNECT]: 'E-connect-IDS',
};